<template>
  <div class="relative flex items-start py-2 pl-1 items-center">
    <div class="flex h-5 items-center">
      <input
        :id="id"
        v-model="model"
        type="checkbox"
        :disabled="disabled"
        class="h-4 w-4 rounded border-gray-300 text-green-main focus:ring-green-main"
      />
    </div>
    <div class="ml-3">
      <label :for="id"><slot /></label>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  id: {
    type: String,
    default: () => (Math.random() + 1).toString(36).substring(7),
  },

  disabled: {
    type: Boolean,
    default: false,
  },

  modelValue: { type: [Array, Boolean], required: true },
})

const model = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits('update:modelValue', value)
    emits('changed')
  },
})

const emits = defineEmits<{
  (e: 'update:modelValue', v: any): void
  (e: 'focus'): void
  (e: 'blur'): void
  (e: 'enter'): void
  (e: 'changed'): void
}>()
</script>

<style scoped></style>
